import Vue from 'vue'
import Vuex from 'vuex'
import workbench from './modules/workbench'
import contextmenu from './modules/contextmenu'
import dialog from './modules/dialog'
import explorer from './modules/explorer'
import search from './modules/search'
import image from './modules/image'
import auth from './modules/auth'

Vue.use(Vuex)

const state = {
  version: ''
}

const getters = {
  version (state) {
    return state.version
  }
}

const mutations = {
  SET_VERSION (state, version) {
    state.version = version
  }
}

export default new Vuex.Store({
  namespaced: true,
  modules: {
    workbench,
    contextmenu,
    dialog,
    explorer,
    search,
    image,
    auth
  },
  state,
  getters,
  mutations
})
